// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1s7Os","label":"Category_label__3-zEr","content":"Category_content__1m-Jt","header":"Category_header__3zG-5","location":"Category_location__3TXgD"};